
export { CollectionName } from "/codebuild/output/src2254412836/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"